/**
 * CAOSLAB.DEV — BENTO & CARDS INTERACTIVITY
 * Handles dynamic radial mouse tracking, 3D tilt micro-animations,
 * and animated metric counters with ZERO forced reflows.
 */

export function initBentoEffects() {
  const cards = document.querySelectorAll('.glass-card, .bento-card, .showcase-card');

  cards.forEach(card => {
    let rect = null;
    let rafId = null;

    const updateRect = () => {
      rect = card.getBoundingClientRect();
    };

    card.addEventListener('mouseenter', updateRect, { passive: true });

    card.addEventListener('mousemove', (e) => {
      if (!rect) rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        card.style.setProperty('--mouse-x', `${x}px`);
        card.style.setProperty('--mouse-y', `${y}px`);
      });
    }, { passive: true });

    card.addEventListener('mouseleave', () => {
      rect = null;
      if (rafId) cancelAnimationFrame(rafId);
    }, { passive: true });
  });

  // Metric Number Counters Animation via IntersectionObserver
  const metricValues = document.querySelectorAll('.metric-value[data-target]');
  if (metricValues.length === 0) return;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const targetStr = el.getAttribute('data-target');
        const prefix = el.getAttribute('data-prefix') || '';
        const suffix = el.getAttribute('data-suffix') || '';
        const target = parseFloat(targetStr);
        const duration = 1800;
        const startTime = performance.now();

        function updateCounter(currentTime) {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          // Ease out cubic
          const easeProgress = 1 - Math.pow(1 - progress, 3);
          const currentVal = target % 1 !== 0 
            ? (easeProgress * target).toFixed(1) 
            : Math.floor(easeProgress * target);

          el.textContent = `${prefix}${currentVal}${suffix}`;

          if (progress < 1) {
            requestAnimationFrame(updateCounter);
          } else {
            el.textContent = `${prefix}${targetStr}${suffix}`;
          }
        }

        requestAnimationFrame(updateCounter);
        obs.unobserve(el);
      }
    });
  }, { threshold: 0.2 });

  metricValues.forEach(val => observer.observe(val));
}
